import { l as lodashExports } from '../../_virtual/lodash.js';
import '../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import 'vue';
import { HtmlConverter } from '../../util/html-converter.js';

const withHtml = (editor, serializers, deserializers) => {
  const newEditor = editor;
  newEditor.htmlElement = null;
  newEditor.setHtml = (html) => {
    if (html.trim() === "") {
      const node = HtmlConverter.textToSlateNode("", deserializers);
      if (node) {
        newEditor.children = [node];
      }
    } else {
      const nodes = HtmlConverter.htmlToSlateNodes(html, deserializers);
      newEditor.children = nodes;
    }
  };
  Object.defineProperty(newEditor, "html", {
    get() {
      const children = lodashExports.cloneDeep(newEditor.children);
      const html = HtmlConverter.slateNodeToHtml(children, serializers);
      return html;
    },
    set(html) {
      newEditor.setHtml(html);
    },
    enumerable: true,
    configurable: true
  });
  return newEditor;
};

export { withHtml };
//# sourceMappingURL=with-html.js.map
